<template>
  <a-modal
    width="600px"
    centered
    v-model:open="loginModalVisible"
    @cancel="
      $emit('close');
      loginQrState = false;
    "
    :maskStyle="{
      'background-color':
        document.documentElement.offsetWidth > 600 ? '' : 'rgba(0, 0, 0, 0)',
    }"
    :maskClosable="false"
    class="loginModaCla"
  >
    <div class="register50">
      <img
        style="width: 100%"
        :src="`https://img.cyuai.com/cpn/material/a53afeee6a4447a5b041b9b3e9bf3ea1.png?${dayjs().format(
          'YYYYMMDDHH'
        )}`"
        alt="img"
      />
    </div>
    <div
      class="login"
      :style="{
        backgroundImage: `url(
          https://img.cyuai.com/cpn/material/91b21e549ea24391a80d04a0e2d83367.png?${dayjs().format(
            'YYYYMMDDHH'
          )}
        )`,
      }"
    >
      <div class="login_card">
        <!-- 标题 -->
        <div class="title">
          <img src="@/assets/logo.png" />
          <div class="titlValue">欢迎登录晨羽智云</div>
        </div>
        <div class="regiter">
          <!-- 密码短信 -->
          <div class="passcodeLock">
            <!-- 1密码 2验证码 3扫码后绑定手机号 -->
            <div class="loginSwitch">
              <div
                class="loginSwitchItem"
                :class="{ loginSwitchActive: loginType == 1 }"
                @click="
                  loginType = 1;
                  loginForm.username = loginForm.mobile;
                "
              >
                密码登录
              </div>
              <div
                class="loginSwitchItem"
                :class="{ loginSwitchActive: loginType == 2 || loginType == 3 }"
                @click="
                  loginType = 2;
                  loginForm.mobile = loginForm.username;
                "
              >
                短信登录
              </div>
            </div>
            <a-form :model="loginForm" class="login_form">
              <!-- 验证码 -->
              <div
                class="login_form_item"
                v-if="loginType == 2 || loginType == 3"
              >
                <div class="label">手机号</div>
                <div>
                  <a-input
                    v-model:value="loginForm.mobile"
                    placeholder="请输入手机号码"
                  />
                </div>
              </div>
              <div
                class="login_form_item"
                v-if="loginType == 2 || loginType == 3"
              >
                <div class="label">验证码</div>
                <div class="verification_code">
                  <a-input
                    v-model:value="loginForm.sms_code"
                    placeholder="请输入验证码"
                    maxlength="4"
                    ref="smsCode"
                    @change="
                      () => {
                        if (loginForm.sms_code.length >= 4) {
                          submitLogin();
                        }
                      }
                    "
                  />
                  <div class="sms_btn">
                    <a-button
                      class="button_login newButtonDark"
                      @click="getVerifycode"
                    >
                      {{ smsCodeTxt }}
                    </a-button>
                  </div>
                </div>
              </div>
              <!-- 密码 -->
              <div class="login_form_item" v-if="loginType === 1">
                <div class="label">账号</div>
                <div>
                  <a-input
                    v-model:value="loginForm.username"
                    placeholder="请输入账号或手机号码"
                  />
                </div>
              </div>
              <div class="login_form_item" v-if="loginType === 1">
                <div class="label">密码</div>
                <div>
                  <a-input
                    v-model:value="loginForm.password"
                    placeholder="请输入密码"
                    maxlength="32"
                    type="password"
                    ref="password"
                  />
                </div>
              </div>
              <!-- 登录按钮 -->
              <a-button
                class="login_Button newButtonDark"
                @click="submitLogin"
                html-type="submit"
                :loading="submitLoading"
              >
                {{ loginType == 3 ? "绑定" : "登录" }}
              </a-button>
            </a-form>
          </div>
          <!-- 中间线 -->
          <div class="intermediate"></div>
          <!-- 扫码 -->
          <div class="scanQR">
            <div class="scanTitel">
              <svg
                t="1752650439260"
                class="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="2658"
                width="20"
                height="20"
              >
                <path
                  d="M512 947.9375C271.25 947.9375 76.0625 752.75 76.0625 512 76.0625 271.25 271.25 76.0625 512 76.0625 752.75 76.0625 947.9375 271.25 947.9375 512c0 240.75-195.1875 435.9375-435.9375 435.9375z m0-28.125c225.225 0 407.8125-182.5875 407.8125-407.8125S737.225 104.1875 512 104.1875 104.1875 286.775 104.1875 512 286.775 919.8125 512 919.8125z m89.60625-479.925c-85.10625 0-152.38125 63.50625-152.38125 141.834375 0 12.965625 2.025 25.565625 5.540625 37.51875a203.2875 203.2875 0 0 1-16.734375 0.73125c-22.3875 0-40.33125-4.584375-62.746875-9l-62.634375 31.415625 17.94375-53.915625C285.70625 557.1125 258.875 516.696875 258.875 467.478125 258.875 382.259375 339.59375 315.125 438.03125 315.125c88.0875 0 165.290625 53.6625 180.815625 125.83125a149.203125 149.203125 0 0 0-17.240625-1.06875z m-96.384375-48.571875c-13.44375 0-26.8875 8.859375-26.8875 22.359375 0 13.44375 13.44375 22.415625 26.8875 22.415625 13.5 0 22.415625-8.971875 22.415625-22.415625 0-13.5-8.915625-22.359375-22.415625-22.359375zM379.840625 436.0625c13.44375 0 22.359375-8.971875 22.359375-22.415625 0-13.5-8.915625-22.359375-22.359375-22.359375-13.44375 0-27 8.859375-27 22.359375 0 13.44375 13.55625 22.415625 27 22.415625zM765.125 579.528125c0 40.44375-26.83125 76.190625-62.803125 103.1625l13.5 44.803125-49.134375-26.94375c-17.915625 4.471875-35.915625 9-53.775 9-85.275 0-152.4375-58.21875-152.4375-130.021875 0-71.60625 67.1625-129.99375 152.4375-129.99375 80.55 0 152.2125 58.3875 152.2125 129.99375z m-201.628125-22.415625c13.55625 0 22.415625-8.859375 22.415625-17.8875 0-8.94375-8.859375-17.915625-22.415625-17.915625-8.915625 0-17.8875 9-17.8875 17.915625 0 9 8.971875 17.8875 17.8875 17.8875z m98.55 0c13.44375 0 22.44375-8.859375 22.44375-17.8875 0-8.94375-9-17.915625-22.44375-17.915625-8.859375 0-17.803125 9-17.803125 17.915625 0 9 8.94375 17.8875 17.803125 17.8875z"
                  p-id="2659"
                  fill="#13BF26"
                ></path>
              </svg>
              微信登录
            </div>
            <div class="login_QR_wai">
              <div class="codeQR">
                <div class="image">
                  <img
                    v-if="userLoginQrData.qr_code_url"
                    class="img"
                    :src="userLoginQrData.qr_code_url"
                    @click="userLoginQrFun()"
                  />
                  <LoadingOutlined v-else style="font-size: 20px" />
                </div>
                <div
                  v-if="this.userLoginQrData.pastDueState"
                  class="QR_masking"
                  @click="userLoginQrFun()"
                >
                  <div>已失效</div>
                  <div>点击刷新</div>
                </div>
              </div>
              <div class="scanTip">微信扫码关注公众号完成登录</div>
            </div>
            <!-- 提示 -->
            <div class="tip">
              <ExclamationCircleOutlined style="color: #6378fa" />
              未注册用户将自动登录注册
            </div>
          </div>
        </div>
        <div class="constract_text">
          登录即视为同意
          <span
            @click="mixinOpenNewWindow(`${http_Docs}/agreement`)"
            class="pointer"
            >《<span class="span">用户服务协议</span>》</span
          >、<span
            @click="mixinOpenNewWindow(`${http_Docs}/privacy`)"
            class="pointer"
            ><span class="span">隐私政策</span>》 </span
          >、<span @click="mixinOpenNewWindow(http_Docs)" class="pointer"
            >《<span class="span">授权许可协议</span>》
          </span>
        </div>
      </div>
    </div>
    <template #footer></template>
    <!-- 图像确认框 -->
    <a-modal
      class="slideCaptchaModal newFooter"
      :destroyOnClose="true"
      centered
      v-model:open="imgConfirmVisible"
      title="图形验证"
      :footer="null"
    >
      <SlideCaptcha
        @slideCaptchaCall="slideCaptchaCall"
        :mobile="loginForm.mobile"
        :mould="2"
      ></SlideCaptcha>
    </a-modal>
  </a-modal>
</template>

<script>
import { mapState, mapActions } from "pinia";
import { useHomeStore } from "../store";
import {
  LoadingOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons-vue";
import SlideCaptcha from "@/components/slideCaptcha";
export default {
  components: { SlideCaptcha, LoadingOutlined, ExclamationCircleOutlined },
  name: "login",
  data() {
    return {
      document: document, // 页面文档
      loginModalVisible: true,
      // 登录完成后重定向地址
      redirect: null,
      loginType: 1, // 1密码 2验证码 3扫码后绑定手机号
      userLoginQrData: {},
      loginQrState: false, // 二维码等待中
      loginForm: {
        mobile: "", // 15090669190
        sms_code: "", // 1234
        username: "",
        password: "",
      },
      smsCodeTxt: "获取验证码",

      submitLoading: false,
      QrSetTimeout: null,
      ScanSetTimeout: null,

      // 验证图像验证码
      imgConfirmVisible: false,
    };
  },
  watch: {
    $route: {
      handler: function (route) {
        this.redirect = route.query && route.query.redirect;
      },
      immediate: true, // 这样初始化的时候也会触发
      deep: true, // 它会进行深度监听
    },
  },
  props: {},
  created() {
    console.log(window.innerWidth);
    if (window?.innerWidth && window.innerWidth > 600) {
      this.userLoginQrFun();
    }
  },
  mounted() {
    console.log("login页面 mounted");
  },
  computed: {
    ...mapState(useHomeStore, ["token", "user"]),
  },
  beforeUnmount() {
    clearTimeout(this.QrSetTimeout);
    this.QrSetTimeout = null;

    clearTimeout(this.ScanSetTimeout);
    this.ScanSetTimeout = null;

    this.loginQrState = false;
  },
  methods: {
    ...mapActions(useHomeStore, ["changeToken", "changeUser"]),
    // 扫码登录↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓
    // 请求微信登陆二维码
    userLoginQrFun() {
      this.userLoginQrData = {};

      this.$http
        .POST(this.$manageUrl.userLoginQr, {})
        .then((res) => {
          if (res) {
            console.log(res);
            this.userLoginQrData = res.result;

            this.userLoginQrData.time = new Date(); // 倒计时开始时间
            this.loginQrState = true; // 登陆中

            this.countDown();
            this.userLoginScanFun();
          }
        })
        .catch((error) => {
          console.log(error);
          this.$message.error(error.msg || error.message || "ERROR");
        });
    },
    // 二维码有效期
    countDown() {
      clearTimeout(this.QrSetTimeout);
      this.QrSetTimeout = null;

      if (
        this.userLoginQrData.qr_code_url &&
        // 必须不是过期状态，已经过期了就没必要继续刷新一次了
        !this.userLoginQrData.pastDueState &&
        this.loginQrState
      ) {
        // console.log(
        //   (new Date().getTime() - this.userLoginQrData.time.getTime()) / 1000
        // );
        if (
          (new Date().getTime() - this.userLoginQrData.time.getTime()) / 1000 >=
          this.userLoginQrData.qr_expire_seconds
        ) {
          this.userLoginQrData.pastDueState = true;
        } else {
          this.QrSetTimeout = setTimeout(() => {
            this.countDown();
          }, 1000);
        }
      }
    },
    // 登录微信验证
    userLoginScanFun() {
      clearTimeout(this.ScanSetTimeout);
      this.ScanSetTimeout = null;

      if (
        this.userLoginQrData.qr_code_url &&
        !this.userLoginQrData.pastDueState &&
        // 防止临近成功的时候点击了取消，这时既然取消了即便登录成功了也不应该更新用户信息
        this.loginQrState
      ) {
        this.$http
          .POST(this.$manageUrl.userLoginScan, {
            ticket: this.userLoginQrData.qr_ticket,
          })
          .then((res) => {
            if (res.result.token) {
              console.log(res);

              this.userInfoGet(res);
            }
          })
          .catch((error) => {
            console.log(error);
            if (error.code == 6) {
              console.log("去绑定手机号");
              this.$message.error(error.msg || error.message || "ERROR");

              this.loginType = 3;
              this.loginQrState = false; // 登录结束
            }
          })
          .finally(() => {
            if (this.loginQrState) {
              this.ScanSetTimeout = setTimeout(() => {
                this.userLoginScanFun();
              }, 2000);
            }
          });
      }
    },
    // 扫码登录↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑
    // 点击登录
    submitLogin() {
      let formData = this.loginForm;
      let msg = "";
      if (this.loginType === 1) {
        if (!formData.username) {
          msg = "请输入账号";
        } else if (!formData.password) {
          msg = "请输入密码";
          this.$refs["password"].focus();
        }
      } else if (this.loginType == 2 || this.loginType == 3) {
        if (!formData.mobile) {
          msg = "请输入手机号码";
        } else if (!formData.sms_code) {
          msg = "请输入短信验证码";
          this.$refs["smsCode"].focus();
        }
      }
      if (msg) {
        this.$message.warning(msg);
        return;
      } else {
        if (this.loginType == 1) {
          this.login(formData);
        } else if (this.loginType == 2) {
          this.smsLogin(formData);
        } else if (this.loginType == 3) {
          this.qrBindMobileFun();
        }
      }
      // console.log(formData);
    },
    // 0   短信登录
    smsLogin(formData) {
      this.submitLoading = true;
      let data = formData;
      this.$http
        .POST(this.$manageUrl.loginsms, data)
        .then((res) => {
          if (res) {
            this.submitLoading = false;
            this.userInfoGet(res);
          }
        })
        .catch((error) => {
          console.log(error);
          this.submitLoading = false;
          this.$message.error(error.msg || error.message || "ERROR");
        });
    },
    // 1   密码登录
    login(formData) {
      this.submitLoading = true;
      let data = formData;
      this.$http
        .POST(this.$manageUrl.login, data)
        .then((res) => {
          if (res) {
            this.submitLoading = false;
            this.userInfoGet(res);
          }
        })
        .catch((error) => {
          console.log(error);
          this.submitLoading = false;
          this.$message.error(error.msg || error.message || "ERROR");
        });
    },
    // 3   绑定手机号
    qrBindMobileFun() {
      this.submitLoading = true;
      this.$http
        .POST(this.$manageUrl.loginsms, {
          ...this.loginForm,
          ticket: this.userLoginQrData.qr_ticket,
        })
        .then((res) => {
          if (res) {
            this.submitLoading = false;
            this.userInfoGet(res);
          }
        })
        .catch((error) => {
          console.log(error);
          this.submitLoading = false;
          this.$message.error(error.msg || error.message || "ERROR");
        });
    },
    // 请求图片验证码
    getVerifycode() {
      if (this.smsCodeTxt == "获取验证码") {
        let msgText = "";
        if (!this.loginForm.mobile) {
          msgText = "请输入手机号码";
        } else if (
          this.loginForm.mobile &&
          this.loginForm.mobile.length != 11
        ) {
          msgText = "手机号码位数不正确";
        }
        if (msgText != "") {
          this.$message.warning(msgText);
          return;
        }

        this.imgConfirmVisible = true;
      }
    },
    // 请求验证码
    slideCaptchaCall() {
      this.daoshu();
      this.imgConfirmVisible = false;
    },
    // 倒计时
    daoshu() {
      if (this.smsCodeTxt == "获取验证码") {
        this.smsCodeTxt = 60;
        setTimeout(this.daoshu, 1000);
      } else if (this.smsCodeTxt <= 1) {
        this.smsCodeTxt = "获取验证码";
      } else {
        this.smsCodeTxt = this.smsCodeTxt - 1;
        setTimeout(this.daoshu, 1000);
      }
    },

    // 更新存储存储userInfo
    userInfoGet(res) {
      this.loginQrState = false; // 登录结束扫码状态置空

      this.changeToken(res.result.token);
      // this.changeUser(res.result.user);

      this.$message.success(res.msg);
      this.$emit("close");
      this.getInfo().then((e) => {
        if (e) {
          if (this.redirect) {
            this.$router.push(this.redirect);
          } else {
            this.$router.push("/");
          }
        }
      });
    },
  },
};
</script>

<style lang="scss">
@media (max-width: 600px) {
  .slideCaptchaModal {
    .ant-modal-content {
      padding: 10px !important;
    }
  }
}
.loginModaCla {
  .ant-modal-content {
    padding: 0 !important;
  }
}
</style>
<style lang="scss" scoped>
@media (max-width: 600px) {
  .register50 {
    display: none !important;
  }
  .login {
    padding: 20px !important;
    .passcodeLock {
      width: 100% !important;
    }
    .intermediate,
    .scanQR {
      display: none !important;
    }
  }
}
// 广告50
.register50 {
  width: 100%;
  height: 188px;
  position: absolute;
  top: -188px;
  left: 0;
  display: flex;
  align-items: flex-end;
}
.login {
  padding: 25px 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  box-sizing: border-box;
  position: relative;
  font-family: PingFangSC, PingFang SC;
  background-size: 100% 200px;
  background-repeat: no-repeat;
  .login_card {
    width: 100%;
    z-index: 1;
    // 标题
    .title {
      display: flex;
      flex-direction: column;
      align-items: center;
      img {
        width: 60px;
        height: 60px;
        position: relative;
        top: -10px;
      }
      .titlValue {
        font-weight: 600;
        font-size: 27px;
        position: relative;
        top: -20px;
      }
    }
    // 登录框
    .regiter {
      width: 100%;
      display: flex;
      align-items: stretch;
      // 1.密码短线登录
      .passcodeLock {
        width: 60%;
        // 切换方式
        .loginSwitch {
          display: flex;
          align-items: center;
          gap: 20px;
          .loginSwitchItem {
            font-weight: 600;
            font-size: 16px;
            padding-bottom: 5px;
            border-bottom: solid 2px transparent;
            cursor: pointer;
          }
          .loginSwitchActive {
            color: #211bf9;
            border-bottom: solid 2px #211bf9;
          }
        }
        // 表单
        .login_form {
          // 信息输入
          .login_form_item {
            .label {
              font-size: 14px;
              line-height: 14px;
              margin: 20px 0 12px 0;
              color: #000000;
            }
            // 输入框
            .ant-input {
              height: 45px !important;
            }
            .ant-input:hover {
              border-color: #1a2bff;
            }
            .ant-input:focus {
              background: #f6f6ff;
              border-color: #1a2bff;
            }
            // 特殊验证码，短框
            .verification_code {
              display: flex;
              justify-content: space-between;
              align-items: center;
              .sms_btn {
                display: inline-block;
                margin-left: 12px;
                .button_login {
                  width: 100px;
                  height: 45px;
                  padding: 0px !important;
                }
              }
            }
          }
          // 登录按钮
          .login_Button {
            margin-top: 20px;
            width: 100%;
            height: 45px;
          }
        }
      }
      // 中间线
      .intermediate {
        width: 1px;
        flex-shrink: 0;
        background: #c4cceb;
        margin: 0 20px;
      }
      // 扫码登录
      .scanQR {
        display: flex;
        flex-direction: column;
        align-items: center;
        .scanTitel {
          font-size: 16px;
          display: flex;
          align-items: center;
          gap: 5px;
          .icon {
            margin-top: 1px;
          }
        }
        .login_QR_wai {
          margin-top: 15px;
          border-radius: 13px;
          padding: 7px;
          box-sizing: border-box;
          z-index: 1;
          position: relative;
          overflow: hidden;
          display: flex;
          flex-direction: column;
          align-items: center;
          &::before {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            border-radius: 13px;
            padding: 2px;
            background: linear-gradient(
              90deg,
              rgba(117, 218, 255, 0.66),
              rgba(172, 173, 255, 0.68),
              rgba(168, 213, 255, 0.76)
            );
            -webkit-mask: linear-gradient(#fff 0 0) content-box,
              linear-gradient(#fff 0 0);
            mask: linear-gradient(#fff 0 0) content-box,
              linear-gradient(#fff 0 0);
            -webkit-mask-composite: xor;
            mask-composite: exclude;
          }
          // 扫码登录
          .codeQR {
            box-sizing: border-box;
            position: relative;
            .image {
              width: 160px;
              height: 160px;
              display: flex;
              align-items: center;
              justify-content: center;
              .img {
                width: 100%;
                cursor: pointer;
              }
            }
            .QR_masking {
              position: absolute;
              top: 0;
              width: 100%;
              height: 100%;
              background: rgba(255, 255, 255, 0.8);
              backdrop-filter: blur(3px); // 模糊
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              font-size: 18px;
              line-height: 1.2;
              cursor: pointer;
            }
          }
          .scanTip {
            margin-top: 2px;
            font-size: 12px;
          }
        }
        .tip {
          display: flex;
          align-items: center;
          margin-top: 15px;
          font-size: 12px;
          gap: 6px;
        }
      }
    }
    // 协议
    .constract_text {
      width: 100%;
      text-align: center;
      color: #666666;
      font-size: 12px;
      margin-top: 20px;
      word-break: break-all;
      .span {
        color: #211bf9;
      }
    }
  }
}
</style>